import React, { useState } from "react";
import ModalSkeleton from "components/Modals/ModalSkeleton";
import CustomButton from "components/common/Button/CustomButton";
import { toast } from "react-toastify";
import {apiDeleteRequest} from "../../../helpers/Requests";
import {getUrlRole} from "../../../Utils/utils";

const DisconnectModal = (props) => {
  const { closeModal, isOpen, checkPayrollAuthentication, type } = props;
  const [isLoading, setIsLoading] = useState(false);

  const handleDisconnect = async () => {
    try {
      setIsLoading(true);
      const response = await apiDeleteRequest(
          `/${getUrlRole()}/payroll/disconnect/xero`
      );
      if (response.status === 204) {
        toast.success("Payroll Disconnected Successfully!");
        checkPayrollAuthentication();
        closeModal();
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.message ?? "Something Went Wrong!");
    }
  };

  const modalFooter = () => (
      <>
        <CustomButton
            showLoading={isLoading}
            isDisabled={isLoading}
            label='No, Keep Connected'
            clickHandler={closeModal}
        />
        <CustomButton
            showLoading={isLoading}
            isDisabled={isLoading}
            label='Yes, Disconnect'
            variant='danger'
            clickHandler={handleDisconnect}
        />
      </>
  );
  return (
      <ModalSkeleton
          isOpen={isOpen}
          cssClass="w-[30%]"
          title={`XERO Disconnect`}
          closeModal={closeModal}
          modalFooter={modalFooter()}
      >
        <>
          <div>
            <span className="text-sm font-sm mr-1">Are you sure you want to disconnect XERO connection?</span>
          </div>
        </>
      </ModalSkeleton>
  );
};
export default DisconnectModal;
